import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FormInput, FormSelect } from "../../inputs";
import gas from "./assets/gas.png";
import view_less from "./assets/view_less.png";
import broadband from "./assets/broadband.png";
import cable_tv from "./assets/cable_tv.png";
import clubs from "./assets/clubs.png";
import credit_card from "./assets/credit_card.png";
import dth from "./assets/dth.png";
import electricity from "./assets/electricity.png";
import fasttag from "./assets/fasttag.png";
import gas_line from "./assets/gas_line.png";
import hospital from "./assets/hospital.png";
import insurance from "./assets/insurance.png";
import landline from "./assets/landline.png";
import mobile_postpaid from "./assets/mobile_postpaid.png";
import mobile_recharge from "./assets/mobile_recharge.png";
import society from "./assets/society.png";
import water from "./assets/water.png";
import airtel from "./assets/airtel.png";
import bsnl from "./assets/bsnl.png";
import jio from "./assets/jio.png";
import vi from "./assets/vi.png";
import view_more from "./assets/view_more.png";
import edu_fee from "./assets/edu_fee.png";
import loan_repay from "./assets/loan_repay.png";
import municipal_services from "./assets/municipal_services.png";
import recurring_d from "./assets/recurring_d.png";
import PaymentSummary from "./BillPaymentSummary";
import PaymentMethod from "./PayMethod";
import PaymentSuccess from "./PaymentSuccess";
import { headerTitles } from "../../../actions/masterdata/masterdata";
import { useDispatch } from "react-redux";

export const plans = [
  {
    id: 1,
    validity: "Existing Active Plan",
    price: 19,
    data: "1GB",
    voice: "NA",
    sms: "NA",
    description: "Active Plan; For users with an active validity plan.",
    acitve: true,
  },
  {
    id: 2,
    validity: "28 Days",
    price: 349,
    data: "2GB/day",
    voice: "Unlimited Calls",
    sms: "100 SMS/day",
    description: "Unlimited True 5G Data for eligible users.",
  },
  {
    id: 3,
    validity: "Existing Active Plan",
    price: 349,
    data: "1GB",
    voice: "NA",
    sms: "NA",
    description: "For users with an active validity plan.",
  },
  {
    id: 4,
    validity: "90 Days",
    price: 899,
    data: "2GB/day + 20GB extra",
    voice: "Unlimited Calls",
    sms: "100 SMS/day",
    description: "Unlimited True 5G Data for eligible users.",
  },
  {
    id: 5,
    validity: "365 Days",
    price: 3599,
    data: "2.5GB/day",
    voice: "Unlimited Calls",
    sms: "100 SMS/day",
    description: "Unlimited True 5G Data for eligible users.",
  },
  {
    id: 6,
    validity: "365 Days",
    price: 3599,
    data: "2.5GB/day",
    voice: "Unlimited Calls",
    sms: "100 SMS/day",
    description: "Unlimited True 5G Data for eligible users.",
  },
];

const services = [
  { label: "Mobile Recharge", icon: mobile_recharge, active: true },
  { label: "LPG Gas", icon: gas, width: 25 },
  { label: "Broadband", icon: broadband },
  { label: "Cable TV", icon: cable_tv },
  { label: "Clubs", icon: clubs },
  { label: "Credit Card", icon: credit_card },
  { label: "DTH", icon: dth },
  { label: "Electricity", icon: electricity },
  { label: "FASTag Recharge", icon: fasttag },
  { label: "Gas", icon: gas_line },
  { label: "Hospital", icon: hospital },
  { label: "Insurance", icon: insurance },
  { label: "Landline", icon: landline },
  { label: "Mobile Postpaid", icon: mobile_postpaid },
  { label: "Society", icon: society },
  { label: "Water", icon: water },
  { label: "Education Fee", icon: edu_fee },
  { label: "Loan Repayment", icon: loan_repay },
  { label: "Municipal Services", icon: municipal_services },
  { label: "Recurring Deposits", icon: recurring_d },
];

const operator_services = [
  { label: "Airtel", icon: airtel },
  { label: "BSNL", icon: bsnl },
  { label: "Jio", icon: jio },
  { label: "Vi", icon: vi },
];

const UtilityBill = () => {
  const dispatch = useDispatch();
  const [viewMore, setViewMore] = useState(true);
  const [step, setStep] = useState(1);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: {
      mobile_number: "",
      operator: "airtel",
      state: "andhra_pradesh",
      plan: 1,
      planAmount: 19,
    },
  });

  useEffect(() => {
    dispatch(
      headerTitles({
        title: "Utility & Bill Payments",
        description: "",
      })
    );
  }, []);

  const onSubmit = (data) => {
    setStep((s) => s + 1);
    console.log("Form Values:", data);
  };

  const op = watch("operator");
  const pln = watch("plan");

  return (
    <div className="upload_payment_parent send-payment request-money">
      <div className="flex-between sec-head">
        <div className="tabsSection">
          <span className="active">
            {services?.find((ele) => ele.active)?.label}
          </span>
        </div>
      </div>
      <div className="recharge-container">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div style={{ display: step <= 2 ? "block" : "none" }}>
            <div className="bills">
              <ul>
                {viewMore
                  ? services?.slice(0, 7)?.map((ele) => (
                      <li className={ele.active ? "active" : ""}>
                        <img src={ele.icon} width={ele.width ?? 30} />
                        <label>{ele.label}</label>
                      </li>
                    ))
                  : services?.map((ele) => (
                      <li className={ele.active ? "active" : ""}>
                        <img src={ele.icon} width={ele.width ?? 30} />
                        <label>{ele.label}</label>
                      </li>
                    ))}
                <li
                  onClick={() => {
                    setViewMore((b) => !b);
                  }}
                >
                  <img src={viewMore ? view_more : view_less} width={30} />
                  <label>View {viewMore ? "More" : "Less"}</label>
                </li>
              </ul>
            </div>
            <div className="w50 mt2">
              <h2>Choose Biller</h2>

              {/* Mobile Number Input */}
              <div className="pp-form-item">
                <FormInput
                  inline
                  {...register("mobile_number", {})}
                  label={"Mobile Number"}
                  control={control}
                  hideCreateOption={true}
                  placeholder={"Enter"}
                  errors={errors}
                />
              </div>

              <div className="pp-form-item">
                <FormSelect
                  inline
                  {...register("operator")}
                  label={"Operator"}
                  control={control}
                  options={[
                    { label: "Airtel", value: "airtel" },
                    { label: "Jio", value: "jio" },
                    { label: "Vi (Vodafone Idea)", value: "vi" },
                    { label: "BSNL", value: "bsnl" },
                    { label: "MTNL", value: "mtnl" },
                  ]}
                  hideCreateOption={true}
                  placeholder={"Select"}
                  required
                  errors={errors}
                />
              </div>

              {/* State Selection */}
              <div className="pp-form-item">
                <FormSelect
                  inline
                  {...register("state")}
                  label={"State"}
                  control={control}
                  options={[
                    { label: "Andhra Pradesh", value: "andhra_pradesh" },
                    {
                      label: "Arunachal Pradesh",
                      value: "arunachal_pradesh",
                    },
                    { label: "Assam", value: "assam" },
                    { label: "Bihar", value: "bihar" },
                    { label: "Chhattisgarh", value: "chhattisgarh" },
                    { label: "Goa", value: "goa" },
                    { label: "Gujarat", value: "gujarat" },
                    { label: "Haryana", value: "haryana" },
                    { label: "Himachal Pradesh", value: "himachal_pradesh" },
                    { label: "Jharkhand", value: "jharkhand" },
                    { label: "Karnataka", value: "karnataka" },
                    { label: "Kerala", value: "kerala" },
                    { label: "Madhya Pradesh", value: "madhya_pradesh" },
                    { label: "Maharashtra", value: "maharashtra" },
                    { label: "Manipur", value: "manipur" },
                    { label: "Meghalaya", value: "meghalaya" },
                    { label: "Mizoram", value: "mizoram" },
                    { label: "Nagaland", value: "nagaland" },
                    { label: "Odisha", value: "odisha" },
                    { label: "Punjab", value: "punjab" },
                    { label: "Rajasthan", value: "rajasthan" },
                    { label: "Sikkim", value: "sikkim" },
                    { label: "Tamil Nadu", value: "tamil_nadu" },
                    { label: "Telangana", value: "telangana" },
                    { label: "Tripura", value: "tripura" },
                    { label: "Uttar Pradesh", value: "uttar_pradesh" },
                    { label: "Uttarakhand", value: "uttarakhand" },
                    { label: "West Bengal", value: "west_bengal" },
                  ]}
                  hideCreateOption={true}
                  placeholder={"Select"}
                  required
                  errors={errors}
                />
              </div>
            </div>
          </div>

          {step === 1 && (
            <>
              <h2 className="mt2">Our prepaid service providers</h2>
              <div className="operators">
                <ul>
                  {operator_services?.map((ele) => (
                    <li
                      className={
                        ele.label?.toLowerCase() === op ? "active" : ""
                      }
                    >
                      <span>
                        <img src={ele.icon} width={ele.width ?? 30} />
                      </span>
                      <label>{ele.label}</label>
                    </li>
                  ))}
                </ul>
              </div>
              <h2 className="mt2">Service providers state</h2>
              <ul className="service-providers">
                <li className="active">Andhra Pradesh</li>
                <li>Telangana</li>
                <li>Bihar</li>
                <li>Delhi</li>
                <li>Kerla</li>
                <li>More</li>
              </ul>
            </>
          )}
          {step === 2 && (
            <>
              <h2 className="mt2">Select Plan</h2>
              <div className="plans-container">
                <div className="tabs">
                  <button type="button" className="active">
                    Popular
                  </button>
                  <button type="button">True 5G Unlimited</button>
                  <button type="button">Data Addon</button>
                  <button type="button">Smartphone</button>
                  <button type="button">True Unlimited Upgrade</button>
                  <button type="button">Entertainment</button>
                </div>

                <div className="plans-grid">
                  {plans.map((plan) => (
                    <div
                      className={`plan-card ${plan.id === pln ? "active" : ""}`}
                      key={plan.id}
                      onClick={() => {
                        setValue("plan", plan.id);
                        setValue("planAmount", plan.price);
                      }}
                    >
                      <div className="d-flex justify-between">
                        <div className="plan-details">
                          <div className="plan-header">
                            <span className="validity">Validity</span>
                          </div>
                          <h4>{plan.validity}</h4>
                          <p>
                            Data: {plan.data} | Voice: {plan.voice} | SMS:{" "}
                            {plan.sms}
                          </p>
                          <p className="description">{plan.description}</p>
                        </div>
                        <div className="price">₹ {plan.price}</div>
                      </div>
                      <button className="view-more">View More</button>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
          {step == 3 && (
            <PaymentSummary
              operator={operator_services.find(
                (ele) => ele.label?.toLowerCase() === op
              )}
              plan={plans?.find((ele) => ele.id === pln)}
              back={() => setStep((s) => s - 1)}
              mob={watch("mobile_number")}
            />
          )}
          {step == 4 && (
            <PaymentMethod
              operator={operator_services.find(
                (ele) => ele.label?.toLowerCase() === op
              )}
              plan={plans?.find((ele) => ele.id === pln)}
              back={() => setStep((s) => s - 1)}
              mob={watch("mobile_number")}
            />
          )}

          {step == 5 && (
            <PaymentSuccess
              operator={operator_services.find(
                (ele) => ele.label?.toLowerCase() === op
              )}
              plan={plans?.find((ele) => ele.id === pln)}
              back={() => setStep((s) => s - 1)}
              mob={watch("mobile_number")}
              zero={() => {
                setStep(1);
                reset();
              }}
            />
          )}

          {step <= 3 && (
            <div className="action-btns">
              <button
                className="back-btn"
                type="button"
                disabled={step === 1}
                onClick={() => {
                  if (step === 1) {
                    return;
                  }
                  setStep((s) => s - 1);
                }}
              >
                Cancel
              </button>
              <button className="send-btn" type="submit">
                Next
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default UtilityBill;
